import { render } from "./Recover.vue?vue&type=template&id=2fd0d5ac&scoped=true"
import script from "./Recover.vue?vue&type=script&lang=js"
export * from "./Recover.vue?vue&type=script&lang=js"

import "./Recover.vue?vue&type=style&index=0&id=2fd0d5ac&scoped=true&lang=scss"

import exportComponent from "/Users/klous/Documents/beye/src/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd0d5ac"]])

export default __exports__